import { useState, useEffect } from "react";
import { Provider } from "react-redux";
import { useTranslation } from "react-i18next";
import { LoadingProvider } from "@agricircle/shared";
import { useAuthContext } from "@agricircle/shared";
import { useAsyncApi, deserializeJsonapiEntity } from "@agricircle/shared/hooks";
import SoilApp from "./SoilApp";
import Product from "./components/Product";
import { store } from "./redux/store";


const SwitcherApp = () => {
    const { t } = useTranslation();
    const sendRequest = useAsyncApi();
    const { profile, setProfile } = useAuthContext();
    const [delayed, setDelayed] = useState(true);

    useEffect(() => {
        if (profile?.id) return;
        const loadProfile = async () => {
            const result = await sendRequest("GET", "users/myself", null, null, true);
            if (result.status > 300)
                setProfile({ status: result.status });
            else
                setProfile(deserializeJsonapiEntity(result.data));
        };

        loadProfile();
        const timeout = setTimeout(() => setDelayed(false), 500);
        return () => clearTimeout(timeout);
    }, [profile?.id]);

    if (profile == null) return delayed ? null : t("shared:loading");

    if (profile.organization?.roles?.includes("soil") && !window.location.href.endsWith("product")) {
        return <SoilApp />;
    }

    return <Product />;
};

export default () => (<Provider store={store}>
    <LoadingProvider>
        <SwitcherApp />
    </LoadingProvider>
</Provider>);
